import { browserHistory } from 'react-router';
import { getOrganizationId } from '../../organization';
import { ThunkDispatcher, RootState, ThunkResult } from '../../../stores/types';

export default function goToCreateExperiencePage(): ThunkResult<void> {
  return (
    _dispatch: ThunkDispatcher,
    getState: () => RootState,
  ): void => {
    const organization = getOrganizationId(getState());
    browserHistory.push(`/${organization}/experience/create`);
  };
}
